import React from 'react'
import DeclineContent from './DeclineContent'

export default function DeclinePage () {
  return (
    <div className='declinePage web'>
      <DeclineContent />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/privacy_center/decline/DeclinePage.jsx